import { InsuranceDetails } from 'Api/insurance';
import { StatusCwp } from 'Api/insurance/types/insurance.types.cwp';
import { InsuranceStatus } from 'Constants/insuranceStatus.constants';
import { ProductName } from 'Constants/products.constants';
import { isDeregisterableVehicleInsurance } from 'Utils/insuranceTypes/insuranceTypes.utils';

export const isAutomaticallyCancellableVehicleInsurance = (
  insuranceDetails: InsuranceDetails,
): boolean => {
  const isDeregisterable = isDeregisterableVehicleInsurance(
    insuranceDetails.insuranceProduct,
  );

  const isDeregistered =
    'isDeregistered' in insuranceDetails && insuranceDetails?.isDeregistered;

  return isDeregisterable && isDeregistered;
};

export const isAutomaticallyCancellableInsurance = (
  insuranceDetails: InsuranceDetails,
): boolean => {
  const { isCancelable, insuranceProduct, insuranceStatus, detailsCwp } =
    insuranceDetails;
  const isActiveInsurance =
    insuranceStatus === InsuranceStatus.ACTIVE ||
    detailsCwp.status.today === StatusCwp.UNDER_RENEWAL;
  const canCancel = isCancelable && isActiveInsurance;
  const isStbAgreement = insuranceProduct.includes('_STB_');
  const isAkaAgreement = insuranceProduct.includes('AKA_');

  return canCancel && !isStbAgreement && !isAkaAgreement;
};

export function validateAccountNumberMod11(
  kontonummer?: string | null,
): boolean {
  if (!kontonummer) {
    return false;
  }

  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const kontonummerWithoutSpacesAndPeriods = kontonummer.replace(/[\s.]+/g, '');
  if (kontonummerWithoutSpacesAndPeriods.length !== 11) {
    return false;
  }
  const sjekksiffer = parseInt(
    kontonummerWithoutSpacesAndPeriods.charAt(10),
    10,
  );
  const kontonummerUtenSjekksiffer =
    kontonummerWithoutSpacesAndPeriods.substring(0, 10);
  let sum = 0;
  for (let index = 0; index < 10; index += 1) {
    sum +=
      parseInt(kontonummerUtenSjekksiffer.charAt(index), 10) * weights[index];
  }
  const remainder = sum % 11;
  return sjekksiffer === (remainder === 0 ? 0 : 11 - remainder);
}

export const showElectricScooterCwpCancellationForm = (
  insurance: InsuranceDetails,
  toggle: boolean,
): boolean =>
  insurance.insuranceProduct === ProductName.ELECTRIC_SCOOTER && toggle;

export const showTravelCwpCancellationForm = (
  insurance: InsuranceDetails,
  toggle: boolean,
): boolean => insurance.insuranceProduct === ProductName.TRAVEL && toggle;

export const showAkaHouseContentsCwpCancellationForm = (
  insurance: InsuranceDetails,
  toggle: boolean,
): boolean =>
  insurance.insuranceProduct === ProductName.AKA_HOUSE_CONTENTS && toggle;

export const showAkaTravelCwpCancellationForm = (
  insurance: InsuranceDetails,
  toggle: boolean,
): boolean => insurance.insuranceProduct === ProductName.AKA_TRAVEL && toggle;

export const showAkaStudentCwpCancellationForm = (
  insurance: InsuranceDetails,
  toggle: boolean,
): boolean => insurance.insuranceProduct === ProductName.AKA_STUDENT && toggle;
